// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallState__loader-dba2fc {
  margin: 0 6px;
}

.CallState__is-calling-d18990 {
  display: flex;
  align-items: center;
}

.CallState__full-hd-c90b02 {
  display: inline-block;
  color: var(--addition-50);
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  padding: 2px;
  border-radius: 4px;
  background: var(--addition-110_70);
  margin-inline-start: 8px;
  height: fit-content;
}

.CallState__active-call-f8fed4 {
  display: flex;
  flex-direction: row;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/CallState/CallState.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,qBAAA;EACA,yBAAA;EACA,4BAAA;EACA,8CAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,wBAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAEF","sourcesContent":[".loader {\n  margin: 0 6px;\n}\n.is-calling {\n  display: flex;\n  align-items: center;\n}\n\n.full-hd {\n  display: inline-block;\n  color: var(--addition-50);\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  padding: 2px;\n  border-radius: 4px;\n  background: var(--addition-110_70);\n  margin-inline-start: 8px;\n  height: fit-content;\n}\n\n.active-call {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `CallState__loader-dba2fc`,
	"is-calling": `CallState__is-calling-d18990`,
	"isCalling": `CallState__is-calling-d18990`,
	"full-hd": `CallState__full-hd-c90b02`,
	"fullHd": `CallState__full-hd-c90b02`,
	"active-call": `CallState__active-call-f8fed4`,
	"activeCall": `CallState__active-call-f8fed4`
};
module.exports = ___CSS_LOADER_EXPORT___;
